module.exports = __webpack_public_path__ + "media/images/icons/rss-815ace27e847136cef467f81f8be5f0e.svg";